export const customers = {
  title: 'Customers',
  subtitle: 'Manage and overview customers',
  new: 'New customer',
  view: 'Customer details',
  export: 'Export CSV',
  fields: {
    name: 'Name',
    contact: 'Contact',
    organizations: 'All organizations',
    status: 'Status',
    notes: 'Notes',
    actions: 'Actions',
    companyName: 'Company name',
    companyAddress: 'Company address',
    taxNumber: 'Tax number',
    registrationNumber: 'Registration number',
    bankAccount: 'Bank account',
    additionalPods: 'Additional PODs',
    pod: 'POD',
    firstName: 'First name',
    lastName: 'Last name',
    type: 'Type',
    email: 'Email',
    phone: 'Phone',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    createdBy: 'Created by',
    snapshot: 'Data snapshot',
    representativeName: 'Representative name',
    contractNumber: 'Contract number',
    contactPerson: 'Contact person',
    financialContact: 'Financial contact',
    consumptionData: 'Consumption data',
    contractPeriod: 'Contract period',
    offerPrice: 'Offer price',
    kat: 'KÁT'
  },
  registration: {
    title: 'Join Us!',
    subtitle: 'Please fill out the form below and we will contact you soon. Our professional customer management system will simplify our collaboration.',
    successTitle: 'Registration Successful!',
    successMessage: 'Thank you for your registration! We will contact you soon.',
    confirmationEmail: '',
    submit: 'Submit Registration',
    submitting: 'Submitting...',
    privacy: 'By registering, you accept our',
    privacyLink: 'privacy policy',
    privacyEnd: '.',
    types: {
      individual: 'Individual',
      organization: 'Company'
    },
    fields: {
      customerType: 'Customer Type',
      firstName: 'First Name',
      lastName: 'Last Name',
      companyName: 'Company Name',
      taxNumber: 'Tax Number',
      registrationNumber: 'Registration Number',
      email: 'Email Address',
      companyEmail: 'Company Email Address',
      phone: 'Phone Number',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal Code',
      country: 'Country',
      contactPersonName: 'Contact Person Name',
      contactPersonEmail: 'Contact Person Email',
      contactPersonPhone: 'Contact Person Phone',
      contactPersonPosition: 'Position',
      contactPersonFax: 'Fax',
      bankAccount: 'Bank Account',
      message: 'Message / Comments'
    },
    placeholders: {
      firstName: 'First name',
      lastName: 'Last name',
      companyName: 'Company name',
      taxNumber: '12345678-1-23',
      registrationNumber: '01-09-123456',
      email: 'email@example.com',
      phone: '+36 30 123 4567',
      address: 'Street, house number',
      city: 'City',
      postalCode: '1234',
      country: 'Hungary',
      contactPersonName: 'Full name of contact person',
      contactPersonEmail: 'contact@company.com',
      contactPersonPhone: '+36 30 123 4567',
      contactPersonPosition: 'e.g. CEO',
      contactPersonFax: '+36 1 234 5678',
      bankAccount: '12345678-12345678-12345678',
      message: 'Please describe briefly how we can help...'
    }
  },
  status: {
    active: 'Active',
    inactive: 'Inactive'
  },
  tooltips: {
    edit: 'Edit',
    delete: 'Delete',
    addOrg: 'Add organization',
    activate: 'Activate',
    deactivate: 'Deactivate',
    viewDocuments: 'View documents',
    generateDocument: 'Generate document',
    view: 'View details',
    publicRegistration: 'Registered via public registration link',
    assignOrganizations: 'Assign organizations'
  },
  messages: {
    deleteConfirm: 'Are you sure you want to delete this customer?',
    noMoreOrgs: 'No more organizations to add',
    noDocuments: 'No documents uploaded for this customer',
    confirmTitle: 'Customer deletion',
    deleteQuestion: 'Are you sure you want to delete this customer?',
    deleteWarning: 'This action cannot be undone.',
    documentGenerationStarted: 'Document generation started:',
    organizationsUpdated: 'Organizations updated successfully',
    organizationsUpdateFailed: 'Failed to update organizations'
  },
  documentModal: {
    noDocuments: 'No documents uploaded for this customer',
  },
  form: {
    title: {
      new: 'Create new customer',
      edit: 'Edit customer',
    },
    type: {
      title: 'Customer type',
      individual: 'Individual',
      organization: 'Organization'
    },
    types: {
      individual: 'Individual',
      organization: 'Organization'
    },
    organizations: {
      title: 'Organizations and pricing',
      notes: 'Notes',
      notesPlaceholder: 'Additional notes about the customer...'
    },
    existingRelationship: 'Existing business relationship',
    existingRelationshipNote: 'The "Existing business relationship" note will be added to the notes when saved.',
    basicInfo: {
      title: 'Basic Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      phone: 'Phone Number',
      companyName: 'Company Name',
    },
    companyData: {
      title: 'Company Data',
      taxNumber: 'Tax Number',
      registrationNumber: 'Registration Number',
    },
    address: {
      title: 'Address',
      street: 'Street and Number',
      city: 'City',
      postalCode: 'Postal Code',
      country: 'Country',
    },
    contractDetails: {
      title: 'Contract details',
      contractNumber: 'Contract number',
      companyName: 'Company name',
      companyAddress: 'Company address',
      taxNumber: 'Company tax number',
      registrationNumber: 'Company registration number',
      bankAccount: 'Bank account number',
    },
    contactDetails: {
      title: 'Contact details',
      representativeName: 'Representative name',
      contactName: 'Contact name',
      contactEmail: 'Contact email',
      contactPhone: 'Contact phone',
      contactFax: 'Contact fax',
      contactPosition: 'Contact position',
    },
    financialContact: {
      title: 'Financial contact',
      name: 'Financial contact name',
      email: 'Financial contact email',
      phone: 'Financial contact phone',
    },
    consumptionData: {
      title: 'Consumption data',
      date: 'Date',
      dueDate: 'Due date',
      power: 'Power (kW)',
      profileNumber: 'Profile number',
      consumption: 'Consumption kWh',
    },
    contractPeriod: {
      title: 'Contract period',
      startDate: 'Contract start date',
      endDate: 'Contract end date',
      price: 'Contract price',
    },
    offerPrice: {
      title: 'Offer price',
      price: "Offer price HUF/kWh-EUR/MWh",
      currency: 'Currency',
    },
    kat: {
      title: 'KÁT',
      kat: "KÁT",
      text: "KÁT text",
    },
    pod: {
      title: 'POD',
      pod: 'POD',
      address: 'Customer address',
      measurementType: 'Remote / Profile',
      annualConsumption: 'MÉF / Annual consumption (kWh)',
    },
    additionalPods: {
      title: 'POD {{index}}',
      pod: 'POD {{index}}',
      address: 'Customer address {{index}}',
      measurementType: 'Remote / Profile {{index}}',
      annualConsumption: 'MÉF {{index}} / Annual consumption (kWh)',

    },
    addMore: 'Add more fields',
    documents: {
      title: 'Documents',
      uploadButton: 'Upload document',
      uploading: 'Uploading...',
      empty: 'No documents uploaded',
      view: 'View',
      delete: 'Delete',
      selectType: 'Select type',
      selectTypeDescription: 'Select a type for the documents',
      typeContract: 'Contract',
      typeQuotation: 'Quotation',
      typeOther: 'Other',
    }
  },
  viewModal: {
    title: 'Customer data',
    address: 'Address',
    street: 'Street',
    city: 'City',
    postalCode: 'Postal code',
    noOrganizations: 'No organizations assigned'
  },
  assignOrganizations: 'Assign Organizations',
  selectOrganizations: 'Select Organizations',
  selectedOrganizations: 'Selected Organizations',
  noOrganizationsSelected: 'No organizations selected',
  history: {
    title: 'Change history for {{name}}',
    noHistory: 'No change history available',
    noHistoryDetail: 'This customer has no modification history yet, or the history records are not available. New changes will automatically appear here.',
    oldValue: 'Old value',
    newValue: 'New value',
    initialValue: 'Initial value',
    deletedValue: 'Deleted value',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted'
  },
  relationshipLog: {
    title: 'Customer Relationship Log',
    noLogs: 'No relationship logs found for this customer',
    noOpenLogs: 'No open tasks found for this customer',
    add: 'Add new log entry',
    edit: 'Edit log entry',
    update: 'Update entry',
    delete: 'Delete log entry',
    confirmDelete: 'Are you sure you want to delete this log entry?',
    addSuccess: 'Log entry added successfully',
    addError: 'Failed to add log entry',
    editSuccess: 'Log entry updated successfully',
    editError: 'Failed to update log entry',
    deleteSuccess: 'Log entry deleted successfully',
    deleteError: 'Failed to delete log entry',
    entryId: 'Entry ID',
    content: 'Content',
    contentRequired: 'Content is required',
    customerRequired: 'Please select a customer',
    createdAt: 'Created at',
    createdBy: 'Created by',
    save: 'Save entry',
    cancel: 'Cancel',
    contentPlaceholder: 'Enter log content (max 1000 characters)...',
    maxLength: 'Maximum 1000 characters',
    searchPlaceholder: 'Search by customer, content, or ID...',
    noResultsFilter: 'No logs match your filters',
    isOpenTask: 'Mark as having pending tasks',
    isOpenTaskDescription: 'Check this if there are pending tasks related to this log entry',
    hasOpenTasks: 'Has pending tasks',
    noOpenTasks: 'No pending tasks',
    pendingTaskDescription: 'There are still pending tasks for this log entry',
    completedTaskDescription: 'All tasks for this log entry are complete',
    statusOpen: 'Open',
    statusClosed: 'Closed',
    filterOpenOnly: 'Open tasks only',
    statusFilter: 'Filter by Status'
  },
  tabs: {
    details: 'Details',
    relationshipLog: 'Relationship Log',
    history: 'History',
    access: 'Access'
  },
  actions: {
    view: 'View'
  },
  bulkActions: {
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selected: '{{count}} selected',
    deleteSelected: 'Delete Selected',
    confirmDelete: 'Are you sure you want to delete {{count}} selected customers?',
    confirmDeleteMessage: 'This action cannot be undone. Customers and all related data will be permanently deleted.',
    deleteSuccess: '{{count}} customers deleted successfully',
    deletePartialSuccess: '{{success}} customers deleted, {{failed}} failed',
    deleteFailed: 'Failed to delete customers'
  },
  contactPersons: {
    title: 'Contact Persons',
    add: 'Add Contact Person',
    noContacts: 'No contact persons added',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    position: 'Position',
    namePlaceholder: 'Contact person name',
    emailPlaceholder: 'email@example.com',
    phonePlaceholder: '+1 234 567 8900',
    positionPlaceholder: 'e.g. CEO',
    setPrimary: 'Primary Contact',
    primaryContact: 'Primary Contact',
    registered: 'Registered',
    invitationSent: 'Invitation Sent',
    sendInvitation: 'Send Invitation',
    nameEmailRequired: 'Name and email are required',
    sendInvitationTo: 'Send invitation to: {{name}}',
    sendInvitationToAll: 'Send invitation to all',
    selectContact: 'Select contact person',
    allContacts: 'All contact persons'
  }
}